import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CommonTable from "../../../common-components/common-tables/CommonTable";
import {
  ReloadIcon,
  XCircleIcon,
  CheckIcon,
  XIcon,
  AlertIcon,
  PersonIcon,
  CallIcon,
  InfoCircleIcon,
  EmailIcon,
} from "../../../../images/icons/icons";
import {
  convertTimeRangeTo12HourFormat,
  formatDateToDisplay,
} from "../../../common-data/Converts";
import InfoPopover from "../../../pt-trials/pt-reports/re-usablee/InfoPopover";

const TMECheckinAnalysisLogs = ({
  // isPage,
  // setIsPage,
  // pageLimit,
  // setPageLimit,
  callFunction,
}) => {
  const {
    tmeCheckinTimeline,
    tmeCheckinTimelineError,
    tmeCheckinTimelineLoading,
  } = useSelector((state) => state.prospects);

  const iniDatas = {
    pagination: [],
    tbData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);
  const [activePopover, setActivePopover] = useState(null);

  const handleInfoClick = (row, type, e) => {
    e.stopPropagation();
    const popoverKey = `${row.date}-${type}`;
    setActivePopover(activePopover === popoverKey ? null : popoverKey);
  };

  useEffect(() => {
    if (
      !tmeCheckinTimelineLoading &&
      !tmeCheckinTimelineError &&
      tmeCheckinTimeline?.status &&
      tmeCheckinTimeline?.timeline
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        tbData: tmeCheckinTimeline.timeline,
        pagination: tmeCheckinTimeline?.pagination || [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [tmeCheckinTimelineLoading, tmeCheckinTimelineError, tmeCheckinTimeline]);

  const tbColumns = [
    {
      dataField: "date",
      text: "Date",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data">{formatDateToDisplay(row?.date)}</span>
          </div>
        );
      },
    },
    {
      dataField: "checkin_status",
      text: "checkin status",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data tb-badge-flex tb-badge ${
              row?.outside_shift
                ? "tb-badge-stuck"
                : row?.checkin_status === "both_present"
                ? "tb-badge-success"
                : row?.checkin_status === "member_present"
                ? "tb-badge-success-1"
                : row?.checkin_status === "trainer_present"
                ? "tb-badge-success-2"
                : "not-assigned"
            }`}
          >
            {row?.outside_shift ? (
              <AlertIcon color="#fff" />
            ) : row?.checkin_status === "both_present" ||
              row?.checkin_status === "member_present" ||
              row?.checkin_status === "trainer_present" ? (
              <CheckIcon color="#fff" />
            ) : (
              <XIcon color="#fff" />
            )}
            {row?.checkin_status?.replace(/_/g, " ")}
          </span>
        );
      },
    },
    {
      dataField: "member_checkin_time",
      text: "Member Check-in",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            {row?.member_checkin_time ? (
              <>
                <span className="tb-data tb-icon tb-min-wid-80px">
                  <CheckIcon color="#059669" />
                </span>
                <span className="tb-data">{row?.member_checkin_time}</span>
              </>
            ) : (
              <span className="tb-data tb-icon tb-min-wid-80px">
                <XCircleIcon />
              </span>
            )}
          </div>
        );
      },
    },
    {
      dataField: "trainer_checkin_time",
      text: "Trainer Check-in",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            {row?.trainer_checkin_time ? (
              <>
                <span className="tb-data tb-icon">
                  <CheckIcon color="#059669" />
                </span>
                <span className="tb-data">{row?.trainer_checkin_time}</span>
              </>
            ) : (
              <span className="tb-data tb-icon">
                <XCircleIcon />
              </span>
            )}
          </div>
        );
      },
    },
    {
      dataField: "workout_tracked",
      text: "Workout Tracked",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-icon tb-min-wid-80px">
            {row?.workout_tracked ? <CheckIcon /> : <XCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "rating",
      text: "rating",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-badge tb-badge-primary">
            {parseFloat(row?.rating || 0).toFixed(1) || 0} ★
          </span>
        );
      },
    },
    {
      dataField: "default_trainer_assigned",
      text: "default trainer",
      wrapHeader: true,
      formatter: (_, row) => {
        return (
          <>
            {row?.default_trainer_assigned ? (
              <div className="tb-flex-col">
                <div className="tb-flex">
                  <span className="tb-data tb-info-icon">
                    <PersonIcon />
                  </span>
                  <span className="tb-data">
                    {row?.default_trainer_name || row?.trainer_name || "NA"}
                  </span>
                </div>

                <div className="tb-flex">
                  <span className="tb-data tb-info-icon">
                    <CallIcon />
                  </span>
                  <span className="tb-data">
                    {row?.default_trainer_mobile || row?.trainer_mobile || "NA"}
                  </span>
                </div>
              </div>
            ) : (
              <span className="tb-data tb-icon">
                <XCircleIcon />
              </span>
            )}
          </>
        );
      },
    },
    {
      dataField: "shift_details",
      text: "trainer shift",
      wrapHeader: true,
      formatter: (_, row) => {
        const shiftTimings = row?.shift_details?.map((shift) => {
          const startTime = shift?.shift_start_time
            ? convertTimeRangeTo12HourFormat(shift.shift_start_time)
            : "";
          const endTime = shift?.shift_end_time
            ? convertTimeRangeTo12HourFormat(shift.shift_end_time)
            : "";
          return `${startTime}-${endTime}`;
        });

        const shiftTiming = shiftTimings ? shiftTimings?.join(", ") : "-";

        return (
          <span className="tb-data tb-min-wid-60px">{shiftTiming || "-"}</span>
        );
      },
    },
    {
      dataField: "available_trainers",
      text: "available trainers",
      wrapHeader: true,
      formatter: (_, row) => {
        const trainers = row?.available_trainers || [];

        if (trainers.length === 0) {
          return <span className="tb-data tb-min-wid-80px">NA</span>;
        }

        const trainerData = trainers.map((trainer) => [
          {
            label: "Name",
            value: trainer?.trainer_name || "NA",
            icon: <PersonIcon color="#2c3e50" />,
          },
          {
            label: "Mobile",
            value: trainer?.trainer_mobile || "NA",
            icon: <CallIcon color="#2c3e50" />,
          },
          {
            label: "Email",
            value: trainer?.trainer_email || "NA",
            icon: <EmailIcon color="#2c3e50" />,
          },
        ]).flat();

        return (
          <span
            className="tb-data tb-info-icon tb-link tb-min-wid-80px"
            onClick={(e) => handleInfoClick(row, "trainers", e)}
          >
            <InfoCircleIcon /> view
            <InfoPopover
              isVisible={activePopover === `${row.date}-trainers`}
              onClose={() => setActivePopover(null)}
              title={`Available Trainers (${trainers.length})`}
              data={trainerData}
            />
          </span>
        );
      },
    },
  ];

  return (
    <div className="flex-col-tables-container mt30">
      <div className="tme-tb-header">
        <h3 className="tm-tb-header-title">
          Check-in Timeline ({tmeCheckinTimeline?.timeline?.length || 0} days)
          <button
            className="page-heading-reload-btn"
            onClick={callFunction}
            title="Reload"
            type="button"
          >
            <ReloadIcon />
          </button>
        </h3>
      </div>

      <div className="common-table-container tb-bordered tb-header-sticky">
        <CommonTable
          tableData={allDatas.tbData}
          // tablePagination={allDatas.pagination}
          tableColumns={tbColumns}
          // isPage={isPage}
          // setIsPage={setIsPage}
          // pageLimit={pageLimit}
          // setPageLimit={setPageLimit}
          isLoading={tmeCheckinTimelineLoading}
        />
      </div>
    </div>
  );
};

export default TMECheckinAnalysisLogs;
